const DevicePage = ({}) => {
  return (
    <h2>Страница Кассы</h2>
  );
};

export default DevicePage;